export const pagination = {
    standard: (c) => {
        let config = {
            pageSizeOptions: [ '10', '25', '50', '100' ],
            showSizeChanger: true
        };

        for(let p in c)
            if(!config.hasOwnProperty(p))
                config[p] = c[p];

        return config;
    }
}


export const paginationWithoutPageSize = {
    standard: (c) => {
        let config = {
        };

        for(let p in c)
            if(!config.hasOwnProperty(p))
                config[p] = c[p];

        return config;
    }
}
